export class Package {
  public lengthInUnit: number;
  public widthInUnit: number;
  public heightInUnit: number;
  public weightInUnit: number;
  public loading: boolean = false;
  public stackableDisabled: boolean = false;

  constructor(
    public quantity: number,
    public length: number,
    public width: number,
    public height: number,
    public measurement: number,
    public weight: number,
    public ldm: number,
    public pallet: boolean,
    public stackable: boolean,
    public isMeasurementRequired: boolean = true,
  ) {}

  public getMeasurement(): number {
    return this.measurement;
  }

  public setMeasurement(param: number) {
    this.measurement = +param;
  }

  public getLdm(): number {
    return this.ldm;
  }

  public updateLdm() {
    this.ldm = +((this.length * this.width) / 2.4).toFixed(2);
  }

  public setLdm(ldm: number): void {
    this.ldm = +ldm;
  }

  public setPallet(pallet: boolean): void {
    this.pallet = pallet;
  }

  public setStackable(stackable: boolean): void {
    this.stackable = stackable;
  }

  public setIsMeasurementRequired(isMeasurementRequired: boolean): void {
    this.isMeasurementRequired = isMeasurementRequired;
  }

  public clearDimensions() {
    [this.length, this.width, this.height] = [null, null, null];
  }

  public unifyDimensions() {
    this.length = +Math.cbrt(this.measurement).toFixed(2);
    this.width = +Math.cbrt(this.measurement).toFixed(2);
    this.height = +Math.cbrt(this.measurement).toFixed(2);
  }

  public isValid() {
    return (
      this.quantity >= 1 &&
      (this.measurement > 0 ||
        (!this.isMeasurementRequired && this.length > 0 && this.width > 0)) &&
      this.weight > 0
    );
  }

  public getRequestParams() {
    return {
      quantity: this.quantity,
      length: this.length,
      width: this.width,
      height: this.height,
      weight: this.weight,
      measurement: this.measurement,
      ldm: this.ldm,
      pallet: this.pallet,
      stackable: this.stackable,
    };
  }
}
